import { localStore } from '@/_utils/localstore'

export function authHeader(): object {
  // return authorization header with jwt token
  const user = JSON.parse(localStore.getItem('user') as string)

  if (user && user.access_token) {
    return {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + user.access_token
    }
  } else {
    return {}
  }
}

export function authHeaderUpload(): object {
  const user = JSON.parse(localStore.getItem('user') as string)

  if (user && user.access_token) {
    return {
      'Authorization': 'Bearer ' + user.access_token
    }
  } else {
    return {}
  }
}
